import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { isClickLink } from 'core/utils/helpers/url';
import { isImageAssetVideo } from 'core/utils/helpers/checkIfImageAssetVideo';

function LinkContainer({ dataItem, contentGroupId, children }) {
  const {
    merchant, clickUrl, assets: { shortSummaryText, imageAlternateText, image }, id,
  } = dataItem;

  const getTitle = (openInNewWindow, merchant, shortSummaryText, imageAlternateText) => {
    if (merchant) {
      return openInNewWindow ? `Opens a new window at ${merchant.name}` : `Opens ${merchant.name}`;
    }

    return openInNewWindow ? 'Opens a new window' : (shortSummaryText || imageAlternateText);
  };

  if (isEmpty(clickUrl) || isImageAssetVideo(image)) {
    return <div>{children}</div>;
  }

  const openInNewWindow = isClickLink(clickUrl);
  const title = getTitle(openInNewWindow, merchant, shortSummaryText, imageAlternateText);
  const target = openInNewWindow ? '_blank' : '';

  return (
    <a
      href={clickUrl}
      title={title}
      target={target}
      className="mn_bannerLink"
      data-placement-id={id}
      data-content-group-id={contentGroupId}
      data-test="simple-banner-link"
    >
      {children}
    </a>
  );
}

export default LinkContainer;
